import React, { PropTypes } from 'react';

import './styles.scss';

export const Tick = props => (
  <svg
    className={`tick ${props.className}`}
    viewBox="0 0 150 150"
    style={{ enableBackground: 'new 0 0 150 150' }}
  >
    <title>Tick</title>
    <g>
      <path
        className="layerOne"
        d="M73.6,22c-28.2,0-52.1,24.9-52.1,53.1s25.9,53.1,54.1,53.1c0,
           0-42.8-14.6-42.4-54.1C33.5,31.2,73.6,22,73.6,22z"
      />
      <circle className="layerTwo" cx="74.9" cy="74.4" r="56.7" />
      <g>
        <g>
          <path
            className="layerThree"
            d="M100.1,65.3L72.7,92.7c-0.6,0.6-1.5,1-2.3,1c-0.9,
               0-1.6-0.4-2.2-1L49.8,74.4c-0.6-0.6-0.9-1.4-0.9-2.2
               c0-1,0.2-1.7,0.9-2.3l4.5-4.5c0.6-0.6,1.4-1,2.2-1s1.6,
               0.4,2.2,1l11.4,11.4l20.7-20.5c0.6-0.6,1.4-1,2.2-1c0.9,
               0,1.6,0.4,2.2,1l4.5,4.5c0.6,0.6,0.9,1.4,0.9,2.3C100.9,
               63.9,100.7,64.7,100.1,65.3z"
          />
        </g>
      </g>
    </g>
  </svg>
);

Tick.propTypes = {
  className: PropTypes.string,
};

export default Tick;



// WEBPACK FOOTER //
// ./src/components/shared/tick/main.jsx